import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchCarrierConnect from '../../CarrierConnect/SearchCarrierConnect';
import DataTable from '../../common/DataTable';
import { numOfPage, RentCalculatorColumns } from '../../../constant';
import BatchPagination from '../../batch/BatchPagination';
import { useNavigate } from 'react-router-dom';
import RentReportsFilter from './RentReportsFilter';

/* istanbul ignore next */
const RentListing = () => {
    const { showAccountingMenu } = useSelector((state) => state.accountingReducer);
    const [filterData, setfilterData] = useState({
        pageIndex: 1,
        pageSize: 30,
        totalPages: 1,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        searchKeyword: '',
        rentFrequencyList: [],
        sellerIdList: [],
        companyIdList: [],
        showFilter: false,
        showSearch: false,
    });
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const ListData = [
        { id: 1, warehouse: 'Dallas WH-01', companySeller: 'Acme Corp / AcmeExports', rentFrequency: 'Monthly', baselineRate: 820, variableRate: 820, totalRate: 1640 },
        { id: 2, warehouse: 'Houston WH-02', companySeller: 'GlobalTrade / GT-America', rentFrequency: 'Weekly', baselineRate: 650, variableRate: 650, totalRate: 1300 },
        { id: 3, warehouse: 'Chicago WH-05', companySeller: 'Starline / SL-Imports', rentFrequency: 'Monthly', baselineRate: 1050, variableRate: 1050, totalRate: 2100 },
        { id: 4, warehouse: 'New Jersey WH-07', companySeller: 'BrightMart / BM-Supply', rentFrequency: 'Weekly', baselineRate: 530, variableRate: 530, totalRate: 1060 },
        { id: 5, warehouse: 'Los Angeles WH-09', companySeller: 'Pacific Exports / PacEx', rentFrequency: 'Monthly', baselineRate: 1220, variableRate: 1220, totalRate: 2440 },
        { id: 6, warehouse: 'Dallas WH-01', companySeller: 'MegaShop / MS-Americas', rentFrequency: 'Monthly', baselineRate: 570, variableRate: 570, totalRate: 1140 },
        { id: 7, warehouse: 'Houston WH-02', companySeller: 'PrimeGoods / PG-LLC', rentFrequency: 'Monthly', baselineRate: 960, variableRate: 960, totalRate: 1920 },
        { id: 8, warehouse: 'Chicago WH-05', companySeller: 'NorthStar / NS-Exports', rentFrequency: 'Weekly', baselineRate: 770, variableRate: 770, totalRate: 1540 },
        { id: 9, warehouse: 'New Jersey WH-07', companySeller: 'UnitedFoods / UF-America', rentFrequency: 'Monthly', baselineRate: 1020, variableRate: 1020, totalRate: 2040 },
    ];
    const handleSearchText = (value) => {
        setfilterData({ ...filterData, searchKeyword: value });
    };

    const handleAction = (item, type, isView) => {
        setLoader(true);
        if (type === 'edit' || type === 'view') {
            navigate(`/accounting/rent-list/${item.id}`, {
                state: { isView: type === 'view' }
            });
        }
    };

    const handleFilterToggle = () => {
        setfilterData({ ...filterData, showFilter: !filterData.showFilter });
    };

    const handleReset = () => {
        setfilterData({
            pageIndex: 1,
            pageSize: 30,
            totalPages: 1,
            sortColumn: '',
            sortOrder: 'DESCENDING',
            searchKeyword: '',
            rentFrequencyList: [],
            sellerIdList: [],
            companyIdList: [],
            showFilter: false,
            showSearch: false,
        });
    };

    const handleFilter = () => {
        setfilterData({ ...filterData, showFilter: false });
        getAllRecords();
    };

    const getAllRecords = () => {
        setLoader(true);
        // API call will be implemented here
    }

    return (
        <div className={`${showAccountingMenu ? 'col-10' : 'col-12'}`}>
            <div className=''>
                <div className="main__tile_heading cus-btn-include-sec">
                    <span>
                        Rent Reports
                    </span>
                    <div className="top_right_button_container">
                        <div className="top_right_button_container">
                            <button
                                className="btn cus-seconday-bg-btn top-btn"
                                onClick={() => navigate(`/accounting/rent-list/${0}`)}
                            >
                                Create
                            </button>

                            <button
                                className="btn cus-seconday-bg-btn top-btn addNewProduct"
                                onClick={handleFilterToggle}
                            >
                                Filter
                            </button>
                        </div>
                    </div>
                </div>
                <div className='zIndex2'>
                    <SearchCarrierConnect
                        searchKeyword={filterData.searchKeyword}
                        handleSearchText={handleSearchText}
                        placeholderText="Search by Company, Seller, Warehouse or Frequency"
                    />
                </div>

                {filterData.showFilter && (
                    <RentReportsFilter
                        showFilter={filterData.showFilter}
                        filterData={filterData}
                        setfilterData={setfilterData}
                        handleReset={handleReset}
                        handleFilter={handleFilter}
                    />
                )}

                <div className="main_content cus-page-content-sec srch-pt0">
                    <div className="main_content_table_history">
                        <div className="tableFixHead incomingTbl">
                            <DataTable
                                headers={RentCalculatorColumns}
                                tableData={ListData}
                                actionType={3}
                                handleAction={handleAction}
                                filterData={filterData}
                            />
                        </div>
                    </div>
                    <BatchPagination
                        gridData={ListData}
                        totalVisualRecords={ListData?.length}
                        numberOfPage={filterData.pageSize}
                        numOfPage={numOfPage}
                        loader={loader}
                        currentPage={filterData.pageIndex}
                        totalPages={filterData.totalPages}
                        totalRecords={ListData?.length}
                        setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                        setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value })}
                    />
                </div>
            </div>
        </div>
    );
}

export default RentListing;